import { resolveIcon } from '../../../styles/icons'
import { useState } from 'react'
import styled from 'styled-components'
import useTranslation from '../../../hooks/useTranslation'
import FormElem from '../../cardView/FormElem'
import ModalForm from '../../modal/ModalForm'
import resolveModalForm from '../../../utils/model/resolveModalForm'

const LocationButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    margin-top: 0.75rem;
    padding: 0.5rem 0.75rem;
    background: none;
    border: 1px solid ${({ theme }) => theme.form.border};
    border-radius: 0.5rem;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.font.color};
    cursor: pointer;

    &:hover { border-color: ${({ theme }) => theme.form.activeBorder}; }
`

/**
 * Choose the location a work item is taken from or delivered to.
 *
 * Two variants, decided by the block's own config rather than by the caller:
 *
 * - `radioGroups` present — an unconstrained picker that walks
 *   warehouse → hall → rack → level → position.
 * - otherwise — a stock-filtered list, built from `modalFormRef`, which only
 *   offers locations that actually hold the item.
 */
const InventoryLocationPicker = ({ block, line, lineIndex, linesField, testId, useStore }) => {
    const { t } = useTranslation()
    const [showModal, setShowModal] = useState(false)

    if (block.radioGroups) {
        return (
            <div style={{ marginTop: '0.75rem' }}>
                <FormElem
                    item={{
                        type: 'connect',
                        id: block.id,
                        displayField: block.displayField,
                        label: block.label,
                        entity: block.entity ?? 'location',
                        modalType: 'radioGroup',
                        radioGroups: block.radioGroups,
                        modalTitle: block.modalTitle,
                        selectButtonKey: block.selectButtonKey,
                        valueMap: block.valueMap,
                        persistValue: true,
                        options: { withHeaders: false },
                        fgMargin: '0'
                    }}
                    lineId={line?.id}
                    useStore={useStore}
                    path={[linesField, lineIndex]}
                    validated={false}
                    section={{ meta: {} }}
                />
            </div>
        )
    }

    const modalForm = resolveModalForm(block)
    const label = line?.[block.displayField]

    return (
        <div>
            <LocationButton
                type="button"
                data-testid={testId}
                onClick={() => modalForm.elements.length > 0 && setShowModal(true)}
            >
                {resolveIcon(block.icon)} {t(block.label)}: {label || '—'}
                {modalForm.elements.length > 0 && <span>▼</span>}
            </LocationButton>
            {showModal && modalForm.elements.length > 0 && (
                <ModalForm
                    name={block.modalName}
                    mode="fullscreen"
                    isVisible={showModal}
                    setIsVisible={setShowModal}
                    modalTitle={t(block.modalTitle)}
                    id={modalForm.id}
                    groups={modalForm.elements}
                    submit={modalForm.submit}
                            buttons={modalForm.buttons}
                    useStore={useStore}
                    lineId={lineIndex}
                    testId={testId}
                    path={[linesField, lineIndex]}
                    onClose={() => setShowModal(false)}
                />
            )}
        </div>
    )
}

export default InventoryLocationPicker
